<template lang="pug">
  .field-reporting-id(v-if="$is('reporting-id')")
    .field-value RP{{item.id}}
  .field-reporting-name(v-else-if="$is('reporting-name')")
    .field-value {{item.type.name}}
  .field-reporting-driver-info(v-else-if="$is('reporting-driver-info')")
    driver(:type="'oneLook'", :item="item.driver")
    driver(:type="'driverName'", :item="item.driver")
  .field-reporting-location(v-else-if="$is('reporting-location')")
    .label Location
    .field-value {{item.location}}
  .field-reporting-vehicle(v-else-if="$is('reporting-vehicle')")
    vehicle(:type="'oneLook'", :item="item.vehicle")
  .field-reporting-reported-at(v-else-if="$is('reporting-reported-at')")
    .label Reported at
    .field-value {{$dateFormat(item.created, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
  .field-reporting-updated-at(v-else-if="$is('reporting-updated-at')")
    .label Updated at
    .field-value {{$dateFormat(item.updated, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
  .field-reporting-status(v-else-if="$is('reporting-status')")
    .label Status
    .field-value
      status(:status="item.status")
    .field-value {{item.status}}
</template>
<script type="text/babel">
  import Status from "../Status.vue";
  import Driver from "../../../backoffice/Driver.vue";
  import Vehicle from "../../../backoffice/Vehicle.vue";
  import {mapState} from 'vuex'

  export default {
    name: "ReportingFields",
    components: {
      Vehicle,
      Driver,
      Status
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {
      type() {
        return this.fieldName
      },
      ...mapState({
        configuration: state => state.configuration,
      })
    },
    props: {
      item: Object,
      fieldName: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ReportingFields.vue?7d75763d